




















import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
  components: {}
})
export default class Checkbox extends Vue {
  @Prop({ required: true }) readonly checkboxId!: string | number
  @Prop({ required: true }) checked!: boolean

  passThroughChangeEvent (event: Event) {
    const target = event.target as HTMLInputElement
    this.$emit('update:checked', target.checked)
  }
}
